<template>
  <div class="zsxq">
    <div v-if="facility=='app'" class="content">
      <AbApp/>
    </div>
    <div class="pc" v-else>
      <Pc />
    </div>
  </div>
</template>

<script>
import AbApp from "./app";
import Pc from "./pc";
export default {
  components:{
    AbApp,
    Pc
  },
  data(){
    return{
      facility:""
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  methods:{
    
  }
}
</script>

<style>
.pc{
  background-color: white;
}
</style>
